import { IOption } from '../../base';
import { CreateCompanyFormFields, MessageTypes } from '../consts';
import { IBaseEntity, IBaseServerEntity } from './base.interfaces';

export interface IServerQuestionCategory {
    category_id: number;
    category_name: string;
    percentage: number;
    unanswered: Array<ICompanyQuestion>;
}

export interface IClientQuestionCategory extends IBaseEntity {
    name: string;
    percentage: number;
    questions: Array<ICompanyQuestion>;
}

export interface ICompanyQuestion {
    id: number;
    title: string;
    subtitle?: string;
    options: Array<IOption> | Array<string>;
    type: CompanyQuestionType;
    category: string;
    index: number;
    weight: number;
}

export interface ICompanyAnsweredQuestion extends ICompanyQuestion {
    answer: boolean | string | number | Array<number> | Array<string>;
    answerOptions?: Array<IOption>;
}

export interface ICreateCompanyForm {
    [CreateCompanyFormFields.NAME]: string;
    [CreateCompanyFormFields.ACCEPT_TERMS]: boolean;
}

export enum CompanyQuestionType {
    SINGLE_SELECTION = 'singleSelection',
    MULTI_SELECTION = 'multiSelection',
    FILE_UPLOAD = 'fileUpload',
    BOOLEAN = 'boolean',
    SHORT_TEXT = 'shortText',
    LONG_TEXT = 'longText',
    FREE_TEXT = 'freeText',
}

export interface IQuestionAnswer {
    id?: number;
    answer: string;
}

export interface IClientChat extends IBaseEntity {
    title: string;
    uuid: string;
    messages?: Array<IClientChatHistoryMessage>;
    generatedContent?: Array<IClientChatHistoryMessage>;
}

export interface IServerChatHistoryMessage extends IBaseServerEntity {
    message: string;
    tool_chat: number;
    tool_user: number;
    type: MessageTypes;
    tool_chat_question_template: ICompanyQuestion;
    deleted: boolean;
}

export interface IServerChat extends IBaseServerEntity {
    uuid: string;
    title: string;
    messages?: Array<IServerChatHistoryMessage>;
    generated_content?: Array<IServerChatHistoryMessage>;
}

export interface IServerChatHistory {
    chat_history: Array<IServerChatHistoryMessage>;
    generated_content: Array<IServerChatHistoryMessage>;
}

export interface IClientChatHistoryMessage extends IBaseEntity {
    message: string;
    toolChat: number;
    toolUser: number;
    type: MessageTypes;
    toolChatQuestionTemplate: ICompanyQuestion | null;
}

export interface IClientChatHistory {
    chatHistory: Array<IClientChatHistoryMessage>;
    generatedContent: Array<IClientChatHistoryMessage>;
}
